import { render } from "./CarrinhoPagamento.vue?vue&type=template&id=3e541c1f"
import script from "./CarrinhoPagamento.vue?vue&type=script&lang=js"
export * from "./CarrinhoPagamento.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__